/**
 * PostalAddress type
 * DOC: https://schema.org/PostalAddress
 */

export default ({
  streetAddress,
  addressLocality,
  addressRegion,
  postalCode,
  addressCountry
}) => ({
  '@type': 'PostalAddress',
  ...(streetAddress && {
    streetAddress
  }),
  ...(addressLocality && {
    addressLocality
  }),
  ...(addressRegion && {
    addressRegion
  }),
  ...(addressCountry && {
    addressCountry
  }),
  ...(postalCode && {
    postalCode
  })
});